import React, { useEffect, useState } from 'react';
import type { Team } from '../../../../types';
import { teamService } from '../../services/teamService';

/** 团队所有者/管理员：是否允许凭邀请码加入，以及按账号直接添加成员 */
export const JoinSettings: React.FC<{ team: Team; onMemberUpdate: () => void }> = ({ team, onMemberUpdate }) => {
  const [enabled, setEnabled] = useState(true);
  const [account, setAccount] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<{ ok: boolean; text: string } | null>(null);

  useEffect(() => {
    setMsg(null);
    teamService.getTeamInfo(team.id).then(t => setEnabled(t.inviteJoinEnabled !== false)).catch(() => setMsg({ ok: false, text: '加载入团设置失败' }));
  }, [team.id]);

  const run = async (action: () => Promise<void>, okText: string) => {
    setBusy(true);
    setMsg(null);
    try {
      await action();
      setMsg({ ok: true, text: okText });
    } catch (e: any) {
      setMsg({ ok: false, text: e?.response?.data?.message || '操作失败，请重试' });
    } finally {
      setBusy(false);
    }
  };

  const toggle = () => run(async () => {
    const r = await teamService.setInviteJoin(team.id, !enabled);
    setEnabled(r.inviteJoinEnabled);
  }, enabled ? '已关闭邀请码加入' : '已开启邀请码加入');

  const add = () => run(async () => {
    await teamService.addMemberByAccount(team.id, account.trim());
    setAccount('');
    onMemberUpdate();
  }, '已添加');

  return (
    <div className="bg-gray-50 rounded-lg p-3">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm font-semibold text-gray-800">加入方式</h3>
        <button disabled={busy} onClick={toggle} className="px-2 py-1 text-xs rounded bg-white border border-gray-200 hover:bg-gray-50 disabled:opacity-50">
          {enabled ? '关闭邀请码加入' : '开启邀请码加入'}
        </button>
      </div>
      <div className="text-xs text-gray-500 mb-2">{enabled ? '现在任何人凭邀请码都能加入。' : '已关闭，只能由管理员按账号添加。'}</div>
      <div className="flex gap-2">
        <input
          value={account}
          onChange={e => setAccount(e.target.value)}
          placeholder="对方的用户名或邮箱"
          className="flex-1 min-w-0 px-2 py-1.5 text-xs border border-gray-200 rounded-md bg-white focus:outline-none focus:border-blue-500"
        />
        <button disabled={busy || !account.trim()} onClick={add} className="px-3 py-1.5 text-xs rounded-md bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50">
          添加成员
        </button>
      </div>
      {msg && <div className={`mt-2 text-xs ${msg.ok ? 'text-green-600' : 'text-red-600'}`}>{msg.text}</div>}
    </div>
  );
};
